import React, { useState, useEffect, useRef } from "react";
import {
  Button,
  Card,
  CardBody,
  Input,
  FormGroup,
  Label,
  Row,
  Col,
  Container,
} from "reactstrap";
import useAxios from "hooks/useAxios";
import { toast } from "react-toastify";
import { Formik, Field } from "formik";
import FormikInputField from "components/common/Fields/FormikInputField";
import InputMask from "react-input-mask";
import Confirm from "components/Confirm";
import { NumericFormat } from "react-number-format";
import { ModuleAccess } from "utils/moduleaccess";
import { Tab, Tabs } from "react-bootstrap";
import ErrorBoundary from "components/ErrorBoundary";
import save from "assets/icon/save.svg";
import cancel from "assets/icon/cancel.svg";
import RightArrow from "assets/icon/RightArrowIcon.svg";
import LeftArrow from "assets/icon/LeftArrowicon.svg";

let InvoiceCycleOpt = [];
const RCSFeeBaseOpt = [
  { id: "CER", label: "CER" },
  { id: "PL", label: "PL" },
];

const ApprovalExpireOpt = [
  { id: 1, label: "1 Month" },
  { id: 3, label: "3 Months" },
  { id: 6, label: "6 Months" },
  { id: 12, label: "12 Months" },
];

const CEConfiguration = ({
  converEntityId,
  toggle,
  invoiceStatus,
  module,
  selectedCoveredEntity,
  editCEConfiguration,
}) => {
  const { coveredEntityName } = selectedCoveredEntity;
  const [key, setKey] = useState("faxdetails");

  const [submitting, setSubmitting] = useState(false);
  const [isConfirm, setConfirm] = useState(false);
  const [autoFaxFlag, setAutoFaxStatus] = useState(false);
  const [selectedInvoiceId, setSelectedInvoice] = useState(-1);
  const [selectedRCSFeebase, setSelecteddRCSFeebase] = useState("CER");
  const [selectedAutoApproveExpire, setselectedAutoApproveExpire] =
    useState("");
  const [faxNumber, setFaxNumber] = useState("");
  const [authFaxNumber, setAuthFaxNumber] = useState("");
  const [displayEDMode, setDisplayEDMode] = useState(false);
  const [faxError, setFaxError] = useState("");
  const [authFaxError, setAuthFaxError] = useState("");
  const [rcsFee, setRcsFee] = useState("");
  const [disableInvoieCycle, setDisableInvoieCycle] = useState(false);
  const [coverPageID, setCoverPageID] = useState("");
  const [forwardCECoverPageID, setForwardCECoverPageID] = useState("");
  const [autoApprovalError, setAutoApprovalError] = useState(false);
  const [state, updateState] = useState({
    initialValues: {
      faxNumber: "",
      authFaxNumber: "",
      invoiceCycleID: "",
      invoiceCycle: "",
      rcsFee: "",
      rcsFeeBase: "",
      autoFaxFlag: false,
      tenant: "",
      coverPageID,
      forwardCECoverPageID,
      autoOutboundFaxFlag: false,
      autoApprovalFlag: false,
      approvalExpired: "",
    },
  });

  const API = useAxios();
  const [loading, setLoading] = useState(false);
  const formikRef = useRef();

  const setState = (obj) => updateState((pre) => ({ ...pre, ...obj }));
  const { initialValues } = state;

  const hasPermission = (code) => {
    return ModuleAccess("CON", code);
    //return (module && module.actions.indexOf(code) != -1)
  };
  const onKeyChange = (k) => {
    setKey(k);
  };

  useEffect(() => {
    setDisplayEDMode(!hasPermission("ED"));
    getCoverEntityConfig();
  }, []);

  const getCoverEntityConfig = async () => {
    try {
      setLoading(true);
      const { data } = await API.get(
        `Config/ceconfig/ceconfig/${converEntityId}`,
        {
          hideLoader: true,
        }
      );
      if (data) {
        setState({
          initialValues: {
            faxNumber: data.faxNumber,
            authFaxNumber: data.authFaxNumber,
            invoiceCycleID: data.invoiceCycleID,
            invoiceCycle: data.invoiceCycle,
            rcsFee: data.rcsFee,
            rcsFeeBase: data.rcsFeeBase,
            autoFaxFlag: data.autoFaxFlag,
            tenant: data.tenant,
            coverPageID: data.coverPageID,
            forwardCECoverPageID: data.forwardCECoverPageID,
            autoOutboundFaxFlag: data.autoOutboundFaxFlag,
            autoApprovalFlag: data.autoApprovalFlag,
            approvalExpired: data.approvalExpired,
          },
        });
        setRcsFee(data.rcsFee);
        setSelectedInvoice(data.invoiceCycleID);
        setSelecteddRCSFeebase(data.rcsFeeBase);
        setselectedAutoApproveExpire(data.approvalExpired);
        setFaxNumber(data.faxNumber);
        setAuthFaxNumber(data.authFaxNumber);
        setAutoFaxStatus(data.autoFaxFlag);
        setCoverPageID(data.coverPageID);
        setForwardCECoverPageID(data.forwardCECoverPageID);
        if (data.invoiceCycleID !== null) {
          setDisableInvoieCycle(true);
        }
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
    }
  };

  const handleSaveConfirmation = () => {
    setConfirm(!isConfirm);
  };

  const handleSubmit = async (val, action) => {
    handleSaveConfirmation();
    let payload = formikRef.current.values;
    if (payload.autoApprovalFlag && payload.approvalExpired === null) {
      setAutoApprovalError(true);
      return;
    }
    let checkValidFax =
      payload.faxNumber != null && payload.faxNumber.length > 0
        ? payload.faxNumber.replace(/\D/g, "")
        : "";
    if (checkValidFax !== "" && checkValidFax.length < 10)
      return setFaxError(true);

    let checkValidAuthFax =
      payload.authFaxNumber != null && payload.authFaxNumber.length > 0
        ? payload.authFaxNumber.replace(/\D/g, "")
        : "";
    if (checkValidAuthFax !== "" && checkValidAuthFax.length < 10)
      return setAuthFaxError(true);

    if (payload.rcsFee > 100) {
      toast.error("RCS Fee percentage should not be more than 100.");
      return;
    }

    setLoading(true);

    try {
      const result = await API.post(
        `Config/ceconfig/updatececonfig/${converEntityId}`,
        payload
      );
      toast.success("Configuration saved successfully");
      if (result) {
        setLoading(false);
        toggle(false);
      }
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  const handleChange = (e, val) => {
    let frk = formikRef.current.values;
    switch (val) {
      case "fax":
        let faxNum = e.target.value.replace(/\D/g, "");
        frk.faxNumber = faxNum;
        setFaxNumber(faxNum);
        setFaxError(false);
        break;
      case "authfax":
        let authFaxNum = e.target.value.replace(/\D/g, "");
        frk.authFaxNumber = authFaxNum;
        setAuthFaxNumber(authFaxNum);
        setAuthFaxError(false);
        break;
      case "rcsfee":
        frk.rcsFee = e.target.value;
        setRcsFee(e.target.value);
        break;
      case "rcsfeebase":
        frk.rcsFeeBase = e.target.value;
        setSelecteddRCSFeebase(e.target.value);
        break;
      case "invoicecycle":
        frk.invoiceCycleID = e.target.value;
        setSelectedInvoice(e.target.value);
        break;
      case "autofax":
        frk.autoFaxFlag = e.target.checked;
        setAutoFaxStatus(e.target.checked);
        break;
      case "autofaxoutboundstatus":
        frk.autoOutboundFaxFlag = e.target.checked;
        //setAutoFaxStatus(e.target.checked);
        break;
      case "autoapprovestatus":
        frk.autoApprovalFlag = e.target.checked;
        //setAutoFaxStatus(e.target.checked);
        break;
      case "autoapproveexpire":
        frk.approvalExpired = e.target.value;
        setselectedAutoApproveExpire(e.target.value);
        break;
    }
    setState({
      initialValues: frk,
    });
  };

  const hasEditPermission = () => {
    if (hasPermission("ED")) {
      return (
        <Button
          color="primary"
          className="search ms-2"
          onClick={handleSaveConfirmation}
        >
          <span className="right_5">
            <img src={save} alt="" />
          </span>{" "}
          Save
        </Button>
      );
    }
  };
  const onHandelNext = () => {
    if (key == "faxdetails") {
      setKey("coverpage");
    } else if (key == "coverpage") {
      setKey("invoice");
    }
  };
  const onHandelPrevious = () => {
    if (key == "invoice") {
      setKey("coverpage");
    }
    if (key == "coverpage") {
      setKey("faxdetails");
    }
  };
  return (
    <div>
      <Formik
        onSubmit={handleSubmit}
        initialValues={initialValues}
        enableReinitialize={true}
        innerRef={formikRef}
        children={(props) => {
          return (
            <div>
              <Row>
                <Col md={6}>
                  <FormGroup>
                    <Label for="coveredEntity" className="headings">
                      Covered Entity
                    </Label>
                    <div>
                      <p className="d-inline-block font-weight-500 f-14">
                        {`${coveredEntityName || "-"} `}
                      </p>
                    </div>
                  </FormGroup>
                </Col>
                <Col md={6}>
                  <FormGroup>
                    <Label
                      for="tenant"
                      className="headings"
                      style={{
                        color: "#9E9E9E",
                        fontWeight: 500,
                        fontSize: "14px",
                      }}
                    >
                      Tenant
                    </Label>
                    {/* <Field id="tenant" name="tenant" type="text" className="required" autoComplete="off" component={FormikInputField} /> */}
                    <br />
                    <p className="d-inline-plock font-weight-500 f-14">
                      {`${initialValues.tenant || "-"} `}
                    </p>
                  </FormGroup>
                </Col>
              </Row>
              <Container fluid className=" bin_info">
                <Card className="border-0 shadow-top">
                  <CardBody className="">
                    <Tabs
                      id="controlled-tab-example"
                      activeKey={key}
                      onSelect={(k) => onKeyChange(k)}
                      className="mb-3"
                    >
                      <Tab eventKey="faxdetails" title="Fax Details">
                        <ErrorBoundary>
                          <Row>
                            <Col md={6}>
                              <Label check className="toggle-label">
                                Enable Autofax
                              </Label>
                              <FormGroup switch>
                                <Input
                                  type="switch"
                                  id="autoFaxFlag"
                                  name="autoFaxFlag"
                                  onChange={(e) => handleChange(e, "autofax")}
                                  //defaultChecked={initialValues.autoFaxFlag}
                                  checked={initialValues.autoFaxFlag}
                                />
                              </FormGroup>
                            </Col>
                            <Col md={6}>
                              <Label check className="toggle-label">
                                Auto-Update Fax Outbound Status
                              </Label>
                              <br />
                              <FormGroup switch>
                                <Input
                                  type="switch"
                                  id="autofaxoutboundstatus"
                                  name="autofaxoutboundstatus"
                                  onChange={(e) =>
                                    handleChange(e, "autofaxoutboundstatus")
                                  }
                                  //defaultChecked={initialValues.autoFaxFlag}
                                  checked={initialValues.autoOutboundFaxFlag}
                                />
                              </FormGroup>
                            </Col>
                            {/* <Col md={6}>
                              <Label check className="toggle-label">
                                Auto Approval
                              </Label>
                              <FormGroup switch>
                                <Input
                                  type="switch"
                                  id="autoapprovestatus"
                                  name="autoapprovestatus"
                                  onChange={(e) =>
                                    handleChange(e, "autoapprovestatus")
                                  }
                                  //defaultChecked={initialValues.autoFaxFlag}
                                  checked={initialValues.autoApprovalFlag}
                                />
                              </FormGroup>
                            </Col> */}
                            {/* <Col md={6} className="auto-approve">
                              <FormGroup>
                                <Label check className="toggle-label">
                                  Auto Approval Expires After
                                </Label>
                                <Input
                                  disabled={!initialValues.autoApprovalFlag}
                                  id="autoapproveexpire"
                                  name="autoapproveexpire"
                                  type="select"
                                  value={selectedAutoApproveExpire}
                                  hidden={displayEDMode}
                                  onChange={(e) =>
                                    handleChange(e, "autoapproveexpire")
                                  }
                                >
                                  <option value={""}>----Select----</option>
                                  {ApprovalExpireOpt.map((status) => {
                                    const { id, label } = status;
                                    return (
                                      <option key={id} value={id}>
                                        {label}
                                      </option>
                                    );
                                  })}
                                </Input>
                                <div hidden={!displayEDMode}>
                                  <b className="d-inline-block ps-2 font-weight-100">
                                    {`${selectedAutoApproveExpire || "-"} `}
                                  </b>
                                </div>
                                {autoApprovalError && (
                                  <div className="text-danger font-size-12">
                                    Please select month
                                  </div>
                                )}
                              </FormGroup>
                            </Col> */}
                            <Col md={6}>
                              <FormGroup>
                                <Label for="faxNumber">Fax Number</Label>
                                <InputMask
                                  id="faxNumber"
                                  className="form-control"
                                  name="faxNumber"
                                  mask="(999)999-9999"
                                  value={faxNumber}
                                  hidden={displayEDMode}
                                  onChange={(e) => handleChange(e, "fax")}
                                  readOnly={true}
                                  disabled={true}
                                ></InputMask>
                                {faxError && (
                                  <div className="text-danger font-size-12">
                                    Enter valid fax number
                                  </div>
                                )}
                                <div hidden={!displayEDMode}>
                                  <b className="d-inline-block ps-2 font-weight-500">
                                    {`${faxNumber || "-"} `}
                                  </b>
                                </div>
                              </FormGroup>
                            </Col>
                            <Col md={6}>
                              <FormGroup>
                                <Label for="authFaxNumber">CE Fax Number</Label>
                                <InputMask
                                  id="authFaxNumber"
                                  className="form-control"
                                  name="authFaxNumber"
                                  mask="(999)999-9999"
                                  value={authFaxNumber}
                                  hidden={displayEDMode}
                                  onChange={(e) => handleChange(e, "authfax")}
                                ></InputMask>
                                {authFaxError && (
                                  <div className="text-danger font-size-12">
                                    Enter valid auth fax number
                                  </div>
                                )}
                                <div hidden={!displayEDMode}>
                                  <b className="d-inline-block ps-2 font-weight-500">
                                    {`${authFaxNumber || "-"} `}
                                  </b>
                                </div>
                              </FormGroup>
                            </Col>
                          </Row>
                        </ErrorBoundary>
                      </Tab>
                      <Tab eventKey="coverpage" title="Cover Page Details">
                        <ErrorBoundary>
                          <Row>
                            <Col md={6}>
                              <FormGroup>
                                <Label for="coverPageID">Cover Page ID</Label>
                                <Input
                                  type="text"
                                  className="form-control"
                                  hidden={displayEDMode}
                                  id="coverPageID"
                                  name="coverPageID"
                                  value={coverPageID}
                                  readOnly={true}
                                  disabled={true}
                                />
                                <div hidden={!displayEDMode}>
                                  <b className="d-inline-block ps-2 font-weight-500">
                                    {`${initialValues.coverPageID || "-"} `}
                                  </b>
                                </div>
                              </FormGroup>
                            </Col>
                            <Col md={6}>
                              <FormGroup>
                                <Label for="forwardCECoverPageID">
                                  Forward CE Cover Page ID
                                </Label>
                                <Input
                                  type="text"
                                  className="form-control"
                                  hidden={displayEDMode}
                                  id="forwardCECoverPageID"
                                  name="forwardCECoverPageID"
                                  value={forwardCECoverPageID}
                                  readOnly={true}
                                  disabled={true}
                                />
                                <div hidden={!displayEDMode}>
                                  <b className="d-inline-block ps-2 font-weight-500">
                                    {`${
                                      initialValues.forwardCECoverPageID || "-"
                                    } `}
                                  </b>
                                </div>
                              </FormGroup>
                            </Col>
                          </Row>
                        </ErrorBoundary>
                      </Tab>
                      <Tab eventKey="invoice" title="Invoice Details">
                        <ErrorBoundary>
                          <Row>
                            <Col md={6}>
                              <FormGroup>
                                <Label for="invoiceCycleID">
                                  Invoice Cycle
                                </Label>
                                <Input
                                  id="invoiceCycleID"
                                  name="invoiceCycleID"
                                  type="select"
                                  value={selectedInvoiceId}
                                  hidden={displayEDMode}
                                  onChange={(e) =>
                                    handleChange(e, "invoicecycle")
                                  }
                                  disabled={disableInvoieCycle}
                                >
                                  <option value={""}>--Select--</option>
                                  {invoiceStatus.map((status) => {
                                    const { id, description } = status;
                                    return (
                                      <option key={id} value={id}>
                                        {description}
                                      </option>
                                    );
                                  })}
                                </Input>
                                <div hidden={!displayEDMode}>
                                  <b className="d-inline-block ps-2 font-weight-500">
                                    {`${initialValues.invoiceCycle || "-"} `}
                                  </b>
                                </div>
                              </FormGroup>
                            </Col>
                            <Col md={6}>
                              <FormGroup>
                                <Label for="rcsFee">
                                  RCS Fee (<i>Percentage</i>)
                                </Label>
                                <NumericFormat
                                  className="form-control"
                                  hidden={displayEDMode}
                                  value={rcsFee}
                                  id="rcsFee"
                                  name="rcsFee"
                                  decimalScale={2}
                                  onChange={(e) => handleChange(e, "rcsfee")}
                                />
                                <div hidden={!displayEDMode}>
                                  <b className="d-inline-block ps-2 font-weight-500">
                                    {`${initialValues.rcsFee || "-"} `}
                                  </b>
                                </div>
                              </FormGroup>
                            </Col>
                            <Col md={6}>
                              <FormGroup>
                                <Label for="rcsFeeBase">RCS Fee Base</Label>
                                <Input
                                  id="rcsFeeBase"
                                  name="rcsFeeBase"
                                  type="select"
                                  value={selectedRCSFeebase}
                                  hidden={displayEDMode}
                                  onChange={(e) =>
                                    handleChange(e, "rcsfeebase")
                                  }
                                >
                                  <option value={""}>--Select--</option>
                                  {RCSFeeBaseOpt.map((status) => {
                                    const { id, label } = status;
                                    return (
                                      <option key={id} value={id}>
                                        {label}
                                      </option>
                                    );
                                  })}
                                </Input>
                                <div hidden={!displayEDMode}>
                                  <b className="d-inline-block ps-2 font-weight-500">
                                    {`${selectedRCSFeebase || "-"} `}
                                  </b>
                                </div>
                              </FormGroup>
                            </Col>
                          </Row>
                        </ErrorBoundary>
                      </Tab>
                    </Tabs>
                    <Row>
                      <Col
                        style={{
                          display: "flex",
                          justifyContent: "flex-end",
                          marginTop: "10px",
                        }}
                      >
                        {key == "faxdetails" && (
                          <Button
                            color="primary"
                            className="reset ms-2"
                            onClick={editCEConfiguration}
                          >
                            <span className="right_5">
                              <img src={cancel} alt="" />
                            </span>{" "}
                            Cancel
                          </Button>
                        )}
                        {key == "coverpage" || key == "invoice" ? (
                          <Button
                            color="primary"
                            className="reset ms-2"
                            onClick={onHandelPrevious}
                          >
                            <span className="right_5">
                              <img src={LeftArrow} alt="" />
                            </span>{" "}
                            Previous
                          </Button>
                        ) : (
                          ""
                        )}
                        {key === "faxdetails" || key === "coverpage" ? (
                          <Button
                            color="primary"
                            className="search ms-2"
                            onClick={onHandelNext}
                          >
                            <span className="right_5">
                              <img src={RightArrow} alt="" />
                            </span>{" "}
                            Next
                          </Button>
                        ) : (
                          ""
                        )}
                        {key == "invoice" && hasEditPermission()}
                      </Col>
                    </Row>
                  </CardBody>
                </Card>
              </Container>
            </div>
          );
        }}
      ></Formik>
      <Confirm
        isOpen={isConfirm}
        loading={loading}
        message="Are you sure you want to save?"
        onToggle={handleSaveConfirmation}
        onCancel={handleSaveConfirmation}
        onContinue={handleSubmit}
      />
    </div>
  );
};

export default CEConfiguration;
